import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Animation, AnimationController, ModalController } from '@ionic/angular';

import { SmartAudioService } from '../../providers/smart-audio.service';

@Component({
  selector: 'app-app-splash',
  templateUrl: './app-splash.component.html',
  styleUrls: ['./app-splash.component.scss'],
})
export class AppSplashComponent implements OnInit {

  @ViewChild("ring1", { read: ElementRef, static: true}) ring1: ElementRef
  @ViewChild("ring2", { read: ElementRef, static: true}) ring2: ElementRef
  @ViewChild("ring3", { read: ElementRef, static: true}) ring3: ElementRef

  constructor(
    private modalCtrl: ModalController,
    private animationCtrl: AnimationController,
    private audioSvc: SmartAudioService
    ) { }

  ngOnInit() {
  }

  ionViewDidEnter() {

    //Inner ring
    const inner: Animation = this.animationCtrl.create().addElement(this.ring1.nativeElement).duration(1500).iterations(Infinity).keyframes([
        {offset: 0, transform: 'scale(1.0)', opacity: '0.9'},
        {offset: 0.5, transform: 'scale(2.0)', opacity: '0.9'},
        {offset: 1.0, transform: 'scale(3.0)', opacity: '0.9'}
      ]);

    //Middle Ring
    const middle: Animation = this.animationCtrl.create().addElement(this.ring3.nativeElement).duration(1500).iterations(Infinity).keyframes([
      {offset: 0, transform: 'scale(1.0)', opacity: '0.75'},
      {offset: 0.35, transform: 'scale(2.0)', opacity: '0.75'},
      {offset: 0.7, transform: 'scale(3.0)', opacity: '0.75'},
      {offset: 1.0, transform: 'scale(4.0)', opacity: '0.75'},
    ]);

    //Outer Ring
    const outer: Animation = this.animationCtrl.create().addElement(this.ring2.nativeElement).duration(1500).iterations(Infinity).keyframes([
      {offset: 0, transform: 'scale(1.0)', opacity: '0.5'},
      {offset: 0.25, transform: 'scale(2.0)', opacity: '0.5'},
      {offset: 0.50, transform: 'scale(3.0)', opacity: '0.5'},
      {offset: 0.75, transform: 'scale(4.0)', opacity: '0.5'},
      {offset: 1.0, transform: 'scale(5.0)', opacity: '0.5'}
    ]);

    inner.play();
    middle.play();
    outer.play();



    this.audioSvc.preload("bark", "../../../assets/sounds/animals_dog_bark.mp3");
    this.audioSvc.play("bark");
    
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
    
}
